import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "XhsListViewContainer wd100"
};
const _hoisted_2 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_XhsNoteList = _resolveComponent("XhsNoteList");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_XhsAccountList = _resolveComponent("XhsAccountList");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return $data.permissions.includes('MATERIALS_DASHBOARD') ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event),
    class: "demo-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "笔记",
      name: "0"
    }, {
      default: _withCtx(() => [_createVNode(_component_XhsNoteList)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "账号",
      name: "1"
    }, {
      default: _withCtx(() => [_createVNode(_component_XhsAccountList)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "统计",
      name: "2"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("span", null, "deving", -1)])),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [_createElementVNode("span", null, "不可访问", -1)])));
}